import { render, staticRenderFns } from "./SomethingWrong.vue?vue&type=template&id=e86253ec&lang=html"
import script from "./SomethingWrong.vue?vue&type=script&lang=js"
export * from "./SomethingWrong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports